


























import Vue from "vue";
import InputPrice from "@/encoding/components/buildingBlocks/InputPrice.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        InputPrice: InputPrice,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            inputName:"investment_property_monthly_revenue",
            pathInStore: "transaction.investor.currentMonthlyRentalIncome",
            specificId: uuidv4() as string
        };
    },
    computed: {
        rentalIncome: function(): number {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? 0;
        },
        isDisplayed: function(): boolean {
            let isDisplayed: boolean = this.$store.getters["FormModule/getValue"]("transaction.investor.isInvestmentProperty") === true;
            if (!isDisplayed) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }
            return isDisplayed;
        }
    },
    methods: {
        updateMonthlyRevenue: function(rentalIncome: number): void {
            if (rentalIncome === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": rentalIncome});
            }
        }
    }
});

